import React from 'react'
import { appConfig } from 'config'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'

const PinCustomer = `${appConfig.publicAssetEndpoint}/etc/pin_customer.png`
const PinMerchant = `${appConfig.publicAssetEndpoint}/etc/pin.png`

type Props = {
  lat: number
  long: number
  isMarkerShown?: boolean
  draggable?: boolean
  onDragEnd?: (lat: number, lng: number) => void
  icon?: 'merchant' | 'customer'
}

const MyGoogleMap = (props: Props) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: appConfig?.googleApiKey || '',
  })

  const {
    isMarkerShown = true,
    lat,
    long,
    onDragEnd = () => {},
    draggable = false,
    icon = 'merchant',
  } = props

  const onLoad = React.useCallback(function callback(map) {}, [])

  const onUnmount = React.useCallback(function callback(map) {}, [])

  const Pin = icon === 'merchant' ? PinMerchant : PinCustomer

  const containerStyle = {
    width: '100%',
    height: '300px',
  }

  const center = {
    lat: 15.87,
    lng: 100.9925,
  }

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={{ lat: lat, lng: long }}
      zoom={6}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {isMarkerShown && (
        <Marker
          key={'1'}
          position={{ lat: lat, lng: long }}
          draggable={draggable}
          onDragEnd={(coord: any) => {
            const { latLng } = coord as any
            const lat = latLng.lat()
            const lng = latLng.lng()
            onDragEnd(lat, lng)
          }}
          icon={{
            url: Pin,
            scaledSize: new google.maps.Size(40, 50),
          }}
          onClick={() => {
            //
          }}
        ></Marker>
      )}
    </GoogleMap>
  ) : (
    <>
      <p>Google map not loaded</p>
    </>
  )
}

export default MyGoogleMap
